export default function createCookie(cName, cValue) {
    var expires = "";
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
